app.controller('configIndexCtrl', [
    '$scope', '$rootScope', '$http', '$mdToast', '$state', 'mdContentService', function ($scope, $rootScope, $http, $mdToast, $state, mdContentService) {
    	var vm = this;

        vm.categories = [
    		{
    			key: "welcome",
    			name: "Velkommen-flow"
    		},
    		{
    			key: "exercise",
    			name: "Opgave-flow"
    		},
    		{
    			key: "map",
    			name: "Kortvisning"
    		},
            {
                key: "teacherapp",
                name: "Lærer-app"
            },
            {
                key: "messages",
                name: "Beskeder"
            },
            {
                key: "test",
                name: "Test"
            }
    	];

        vm.configOptions = [
            {
                category: "exercise",
                key: "targetOKDistanceKM",
                description: "How close a student should be to a destination before the 'Next' button is clickable.",
                type: "float",
                defaultValue: 0.05
            },
            {
                category: "welcome",
                key: "allowMapClickThrough",
                description: "Whether to allow the 'Please go to your destination' button to be clicked right away. This means that users can proceed with a given exercise without being close to the target ride.",   
                type: "bool",
                defaultValue: true
            },
            {
                category: "welcome",
                key: "introMoviePassPercentage",
                description: "The percentage at which you're allowed to pass when watching the intro movie in the welcome flow of the app. This is specified as a value between 0.0 and 1.0, which is interpreted as a percentage.",
                type: "float",
                defaultValue: 0.9
            },
            {
                category: "welcome",
                key: "allowSkipIntroMovie",
                description: "Whether or not the intro movie is immediately skippable.",
                type: "bool",
                defaultValue: true
            },
            {
                category: "map",
                key: "mapCenter",
                description: "The center of the map in the app.",
                type: "geopoint",
                defaultValue: [12.5680196, 55.6737266],
            },
            {
                category: "map",
                key: "mapZoom",
                description: "The default zoom level of the map in the app",
                type: "float",
                defaultValue: 16.64
            },
            {
                category: "map",
                key: "mapBearing",
                description: "The bearing of the map",
                type: "float",
                defaultValue: -30.0
            },
            {
                category: "map",
                key: "mapAttribution",
                description: "Vis attribution streng på kortet i app'en",
                type: "bool",
                defaultValue: false
            },
            {
                category: "map",
                key: "mapAttributionString",
                description: "Attribution-strengen som app'en skal bruge på map-visningen.",
                type: "string",
                defaultValue: ""
            },
            {
                category: "map",
                key: "mapDragPitch",
                description: "Slå drag-pitch til for kortet",
                type: "bool",
                defaultValue: false
            },
            {
                category: "map",
                key: "mapDragRotate",
                description: "Slå drag-rotate til for kortet",
                type: "bool",
                defaultValue: false
            },
            {
                category: "map",
                key: "mapDragRotatePitch",
                description: "Slå drag-rotate-pitch til for kortet",
                type: "bool",
                defaultValue: false
            },
            {
                category: "map",
                key: "mapGlobalRideScaleFactor",
                description: "Global skaleringsfaktor for alle forlystelser på kortet",
                type: "float",
                defaultvalue: 1.0
            },
            {
                category: "teacherapp",
                key: "teacherAppUpdateIntervalSecs",
                description: "Opdateringsinterval for lærer-appen (hvor mange sekunder går der imellem lærerappen henter ny data om f.eks. børnenes lokation, opgavefremgang, mm.)",
                type: "int",
                defaultValue: 10
            },
            {
                category: "messages",
                key: "messageServiceUpdateIntervalSecs",
                description: "Opdateringsinterval for beskedservicen i lærer- og elev-app'en. Hvor ofte skal der tjekkes efter nye beskeder?",
                type: "int",
                defaultValue: 30
            },
            {
                category: "test",
                key: "testShowRestartButton",
                description: "Vis Genstart-knappen i elev-appen (Kun til test)",
                type: "bool",
                defaultValue: false
            }
        ];

        vm.prettyCategoryName = function(key) {
            for (var i = 0; i < vm.categories.length; i++) {
                var category = vm.categories[i];
                if (category.key === key) {
                    return category.name;
                }
            }
            return "Unknown";
        }

        vm.parseHierarchy = function() {
            var hier = [];
            for (var i = 0; i < vm.categories.length; i++) {
                var category = vm.categories[i];

                var options = [];
                for (var j = 0; j < vm.configOptions.length; j++) {
                    var configOption = vm.configOptions[j];
                    if (configOption.category !== category.key) {
                        continue;
                    }
                    options.push(JSON.parse(JSON.stringify(configOption)));
                }

                var categoryCopy = JSON.parse(JSON.stringify(category));
                categoryCopy.options = options;
                hier.push(categoryCopy);
            }
            return hier;
        }

        vm.hierarchy = [];
        vm.loading = true;
        vm.configData = null;
        $http.get('/api/gameconfig').then(function(response) {
            vm.loading = false;
            vm.configData = response.data;
            vm.hierarchy = vm.parseHierarchy();

            mdContentService.triggerSyntheticScrollEvent();
        });

        vm.save = function() {
            $http.post('/api/gameconfig', vm.configData).then(function() {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent("Config gemt")
                    .position('top right')
                    .hideDelay(3000)
                );
                $state.reload();
            });
        }
    }
]);